import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "content-block" }, "Log", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "content-block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dx-card responsive-paddings" }, " Put your content here ")
], -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_3))
}